import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const BoletoEnabledMedium = (props: FlagsSvgProps) => {
  return (
    <Svg width={48} height={32} viewBox="0 0 48 32" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_3866" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z"
        fill="white"
      />
      <Path
        d="M4 0V1H44V0V-1H4V0ZM48 4H47V28H48H49V4H48ZM44 32V31H4V32V33H44V32ZM0 28H1V4H0H-1V28H0ZM4 32V31C2.34315 31 1 29.6569 1 28H0H-1C-1 30.7614 1.23858 33 4 33V32ZM48 28H47C47 29.6569 45.6569 31 44 31V32V33C46.7614 33 49 30.7614 49 28H48ZM44 0V1C45.6569 1 47 2.34315 47 4H48H49C49 1.23858 46.7614 -1 44 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_3866)"
      />
      <Path
        d="M14.6246 10.0001C14.3263 10.0001 14.0401 10.1186 13.8291 10.3296C13.6182 10.5406 13.4996 10.8268 13.4996 11.1251V20.8751C13.4996 21.1735 13.6182 21.4596 13.8291 21.6706C14.0401 21.8816 14.3263 22.0001 14.6246 22.0001C14.923 22.0001 15.2092 21.8816 15.4201 21.6706C15.6311 21.4596 15.7496 21.1735 15.7496 20.8751V11.1251C15.7496 10.8268 15.6311 10.5406 15.4201 10.3296C15.2092 10.1186 14.923 10.0001 14.6246 10.0001Z"
        fill="black"
      />
      <Path
        d="M21.3746 10.0001H19.1246C18.5033 10.0001 17.9996 10.5038 17.9996 11.1251V20.8751C17.9996 21.4964 18.5033 22.0001 19.1246 22.0001H21.3746C21.996 22.0001 22.4996 21.4964 22.4996 20.8751V11.1251C22.4996 10.5038 21.996 10.0001 21.3746 10.0001Z"
        fill="black"
      />
      <Path
        d="M25.8746 10.0001C25.5763 10.0001 25.2901 10.1186 25.0791 10.3296C24.8682 10.5406 24.7496 10.8268 24.7496 11.1251V20.8751C24.7496 21.1735 24.8682 21.4596 25.0791 21.6706C25.2901 21.8816 25.5763 22.0001 25.8746 22.0001C26.173 22.0001 26.4591 21.8816 26.6701 21.6706C26.8811 21.4596 26.9996 21.1735 26.9996 20.8751V11.1251C26.9996 10.8268 26.8811 10.5406 26.6701 10.3296C26.4591 10.1186 26.173 10.0001 25.8746 10.0001Z"
        fill="black"
      />
      <Path
        d="M33.3746 10.0001H30.3746C29.7533 10.0001 29.2496 10.5038 29.2496 11.1251V20.8751C29.2496 21.4964 29.7533 22.0001 30.3746 22.0001H33.3746C33.996 22.0001 34.4996 21.4964 34.4996 20.8751V11.1251C34.4996 10.5038 33.996 10.0001 33.3746 10.0001Z"
        fill="black"
      />
      <Path
        d="M10.1248 10.0001C9.82645 10.0001 9.5403 10.1186 9.32932 10.3296C9.11834 10.5405 8.99982 10.8267 8.99982 11.1251V20.8751C8.99982 21.1734 9.11834 21.4596 9.32932 21.6706C9.5403 21.8815 9.82645 22.0001 10.1248 22.0001C10.4232 22.0001 10.7093 21.8815 10.9203 21.6706C11.1313 21.4596 11.2498 21.1734 11.2498 20.8751V11.1251C11.2498 10.9773 11.2207 10.831 11.1642 10.6945C11.1076 10.5581 11.0248 10.434 10.9203 10.3296C10.8158 10.2251 10.6918 10.1422 10.5553 10.0857C10.4188 10.0292 10.2726 10.0001 10.1248 10.0001Z"
        fill="black"
      />
      <Path
        d="M37.8745 10.0001C37.5761 10.0001 37.2899 10.1186 37.079 10.3296C36.868 10.5406 36.7495 10.8268 36.7495 11.1251V20.8751C36.7495 21.1735 36.868 21.4596 37.079 21.6706C37.2899 21.8816 37.5761 22.0001 37.8745 22.0001C38.1728 22.0001 38.459 21.8816 38.6699 21.6706C38.8809 21.4596 38.9995 21.1735 38.9995 20.8751V11.1251C38.9995 10.8268 38.8809 10.5406 38.6699 10.3296C38.459 10.1186 38.1728 10.0001 37.8745 10.0001Z"
        fill="black"
      />
    </Svg>
  )
}
